import React from 'react'
import { MotivationInterface } from '../../../../../common/types/interfaces'
import { ListItem } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: MotivationInterface) => void
  startDuplicate: (el: MotivationInterface) => void
  showDetails: (el: MotivationInterface) => void
  list: MotivationInterface[]
  loading?: boolean
}

export const List = ({ startEdit, startDuplicate, list, showDetails, loading }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет мотивационных схем</div>
      ) : (
        list.map((el) => (
          <ListItem
            el={el}
            startEdit={startEdit}
            startDuplicate={startDuplicate}
            key={el.id}
            showDetails={showDetails}
          />
        ))
      )}
    </div>
  )
}
